import React from 'react';
import { Box, CardContent, FormControlLabel, Typography } from '@mui/material';
import { Checkbox, Divider } from '@biq/apex-ui';
import {
    AttributeIcons,
    attributeStyles,
    getModifiedAttributeIconRecords,
    getNormalizedDisplayAttributeKey,
} from './attribute-helper';
import { DictionaryHighlightIcon } from 'assets/images';

interface AttributeHighlightsProps {
    selectedFilters: string[];
    onFilterChange: (filter: string, action: 'add' | 'remove') => void;
    uniqueAttributeTypes: Set<string>;
}

export const AttributeHighlights = ({
    selectedFilters,
    onFilterChange,
    uniqueAttributeTypes,
}: AttributeHighlightsProps): React.JSX.Element => {
    const modifiedAttributeIcons = getModifiedAttributeIconRecords(
        AttributeIcons,
        uniqueAttributeTypes
    );

    const handleFilterToggle = (filter: string, checked: boolean): void => {
        onFilterChange(filter, checked ? 'add' : 'remove');
    };

    const getNormalizedFilterKey = (value: string): string => {
        return value.toLowerCase().split(' ').join('_');
    };

    return (
        <Box sx={attributeStyles.attributeHighlights.highlightCard}>
            <CardContent
                sx={attributeStyles.attributeHighlights.highlightCardContent}
            >
                <Box
                    sx={attributeStyles.attributeHighlights.imgAndTextContainer}
                >
                    <img
                        src={DictionaryHighlightIcon}
                        alt='Filter Icon'
                        style={
                            attributeStyles.attributeHighlights.highlightIcon
                        }
                    />
                    <Typography
                        variant='overline'
                        sx={attributeStyles.attributeHighlights.highlightText}
                    >
                        Highlight
                    </Typography>
                </Box>
                <Divider
                    sx={attributeStyles.attributeHighlights.dividerContainer}
                />
                <Box
                    sx={attributeStyles.attributeHighlights.highlightContainer}
                >
                    {Object.entries(modifiedAttributeIcons).map(
                        ([key, value]) => {
                            const normalizedDisplayKey =
                                getNormalizedDisplayAttributeKey(key);
                            const normalizedFilterKey =
                                getNormalizedFilterKey(key);
                            const isChecked =
                                selectedFilters.includes(normalizedFilterKey);
                            return (
                                <Box
                                    key={key}
                                    sx={
                                        attributeStyles.attributeHighlights
                                            .highlightBox
                                    }
                                >
                                    <Box
                                        sx={
                                            attributeStyles.attributeHighlights
                                                .imageContainer
                                        }
                                    >
                                        <img
                                            src={value}
                                            alt={key}
                                            style={
                                                attributeStyles
                                                    .attributeHighlights.image
                                            }
                                        />
                                        <Typography>
                                            {normalizedDisplayKey}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={isChecked}
                                                    onChange={(e): void =>
                                                        handleFilterToggle(
                                                            getNormalizedFilterKey(
                                                                key
                                                            ),
                                                            e.target.checked
                                                        )
                                                    }
                                                />
                                            }
                                            label=''
                                            sx={
                                                attributeStyles
                                                    .attributeHighlights
                                                    .checkboxControl
                                            }
                                        />
                                    </Box>
                                </Box>
                            );
                        }
                    )}
                </Box>
            </CardContent>
        </Box>
    );
};
